import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { updateMobileMenuState } from '../redux/menu';
import { getResultData } from '../redux/apiData';
import Link from '@/components/atoms/Link';
import { colorPalette, fonts } from '../styles/styleGuide';
import { hex2rgb, darken } from '../styles/utils';
import getLinkFromPageObject from '../services/getLinkFromPageObject';
import Caret from './shared/icons/Caret';
import get from 'lodash.get';
import withMatch from '@/hocs/withMatch';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    styling: get(getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    }), 'styling', {})
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onNavigate: function onNavigate() {
      dispatch(updateMobileMenuState(false));
    }
  };
};
var MobileMenu = /*#__PURE__*/function (_Component) {
  function MobileMenu() {
    var _this;
    _classCallCheck(this, MobileMenu);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MobileMenu, [].concat(args));
    _defineProperty(_this, "refMap", {});
    _defineProperty(_this, "state", {
      hoverMenuSlug: ''
    });
    _defineProperty(_this, "handleClick", function (slug) {
      var subNavMaxHeight = _this.refMap[slug].offsetHeight;
      _this.setState(function (prevState) {
        return _defineProperty(_defineProperty({}, 'menuItem_' + slug, !prevState['menuItem_' + slug]), 'subNavMaxHeight_' + slug, subNavMaxHeight);
      });
    });
    _defineProperty(_this, "getSubNavMaxHeight", function (state, slug) {
      return state['subNavMaxHeight_' + slug];
    });
    _defineProperty(_this, "getExpandedStatusForItem", function (state, slug) {
      return state['menuItem_' + slug];
    });
    return _this;
  }
  _inherits(MobileMenu, _Component);
  return _createClass(MobileMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        match = _this$props.match,
        _this$props$menuItems = _this$props.menuItems,
        menuItems = _this$props$menuItems === void 0 ? [] : _this$props$menuItems;
      // open active menu item if deep linked, by simulating click on item
      if (match.params.menuSlug && (menuItems || []).some(function (menuItem) {
        return menuItem.slug === match.params.menuSlug && menuItem.pages && menuItem.pages.length > 1;
      })) {
        this.handleClick(match.params.menuSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        match = _this$props2.match,
        styling = _this$props2.styling,
        _this$props2$menuItem = _this$props2.menuItems,
        menuItems = _this$props2$menuItem === void 0 ? [] : _this$props2$menuItem,
        loggedIn = _this$props2.loggedIn,
        onNavigate = _this$props2.onNavigate;
      var _match$params = match.params,
        projectSlug = _match$params.projectSlug,
        env = _match$params.env,
        menuSlug = _match$params.menuSlug,
        pageSlug = _match$params.pageSlug;
      var activeMenuColor = styling.navActiveLabel && env === 'open' ? styling.navActiveLabel : colorPalette.lightBlue;
      return __jsx(Container, {
        "data-id": "components_MobileMenu_Container"
      }, __jsx(MenuItemsWrapper, {
        "data-id": "components_MobileMenu_MenuItemsWrapper"
      }, menuItems.map(function (menuItem) {
        var isCurrentMenu = menuItem.slug === menuSlug;
        var moreThanOnePages = menuItem.pages && menuItem.pages.length > 1;
        return !menuItem.hidden ? __jsx(MenuItem, {
          key: menuItem.id,
          "data-id": "components_MobileMenu_MenuItem"
        }, moreThanOnePages ? __jsx("div", {
          "data-id": "components_MobileMenu_div"
        }, __jsx(MenuItemButton, {
          maxHeight: _this2.getSubNavMaxHeight(_this2.state, menuItem.slug),
          expanded: _this2.getExpandedStatusForItem(_this2.state, menuItem.slug),
          onClick: function onClick() {
            return _this2.handleClick(menuItem.slug);
          },
          name: loggedIn ? 'true' : 'false',
          activeColor: activeMenuColor,
          "data-id": "components_MobileMenu_MenuItemButton"
        }, __jsx("span", {
          "data-id": "components_MobileMenu_span"
        }, menuItem.name), __jsx(CaretContainer, {
          "data-id": "components_MobileMenu_CaretContainer"
        }, __jsx(Caret, {
          direction: "down",
          color: colorPalette.white,
          "data-id": "components_MobileMenu_Caret"
        }))), __jsx(SubNav, {
          "data-id": "components_MobileMenu_SubNav"
        }, __jsx("div", {
          ref: function ref(input) {
            _this2.refMap[menuItem.slug] = input;
          },
          "data-id": "components_MobileMenu_div"
        }, menuItem.pages && menuItem.pages.map(function (submenuItem) {
          return !submenuItem.hidden ? __jsx(SubMenuItem, {
            href: '/' + getLinkFromPageObject({
              projectSlug: projectSlug,
              env: env,
              menuSlug: menuItem.slug,
              pageSlug: submenuItem.slug
            }),
            onClick: onNavigate,
            key: submenuItem.id,
            "data-id": "components_MobileMenu_SubMenuItem"
          }, __jsx(SubMenuItemLabel, {
            isActive: menuSlug === menuItem.slug && pageSlug === submenuItem.slug,
            activeColor: activeMenuColor,
            "data-id": "components_MobileMenu_SubMenuItemLabel"
          }, submenuItem.name)) : null;
        })))) : __jsx(MenuItemLink, {
          href: '/' + getLinkFromPageObject({
            projectSlug: projectSlug,
            env: env,
            menuSlug: menuItem.slug
          }),
          onClick: onNavigate,
          className: isCurrentMenu ? 'isActive' : '',
          color: activeMenuColor,
          name: loggedIn ? 'true' : 'false',
          "data-id": "components_MobileMenu_MenuItemLink"
        }, __jsx("span", {
          "data-id": "components_MobileMenu_span"
        }, menuItem.name, isCurrentMenu))) : null;
      })));
    }
  }]);
}(Component);
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  padding-left: 40rem;\n  padding-bottom: 50rem;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  will-change: transform;\n"])), fonts.primary);
var MenuItemsWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), colorPalette.beige);
var MenuItem = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var MenuItemLink = styled(Link)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-transform: uppercase;\n  display: inline-block;\n  width: 100%;\n  padding: 20rem 30rem;\n  box-sizing: border-box;\n  position: relative;\n  text-decoration: none;\n  background-color: ", ";\n  font-weight: bold;\n\n  > span {\n    display: inline-block;\n    position: relative;\n  }\n\n  &.isActive span {\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      bottom: -10rem;\n      width: 100%;\n      height: 4rem;\n      background-color: ", ";\n      border-radius: 0 0 3rem 0;\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), colorPalette.white, function (props) {
  return props.name === 'false' ? colorPalette.beige : colorPalette.lightBeige;
}, function (props) {
  return props.color;
}, hex2rgb("".concat(colorPalette.beige), 0.3));
var MenuItemButton = styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: left;\n  text-transform: uppercase;\n  display: inline-block;\n  width: 100%;\n  padding: 20rem 45rem 20rem 30rem;\n  box-sizing: border-box;\n  position: relative;\n  text-decoration: none;\n  font-weight: bold;\n  -webkit-tap-highlight-color: transparent;\n\n  ", ";\n\n  + div {\n    transition: max-height 0.22s ease-in-out;\n    max-height: ", "rem;\n    -webkit-backface-visibility: hidden;\n    -webkit-transform-style: preserve-3d;\n    will-change: transform;\n  }\n\n  i {\n    position: absolute;\n    width: 12rem;\n    height: 10rem;\n    right: 30rem;\n    transition: transform 0.2s ease-in-out;\n    top: 50%;\n    transform: translateY(-50%) ", ";\n    transform-origin: center center;\n  }\n\n  svg {\n    position: absolute;\n    width: 100%;\n  }\n"])), colorPalette.white, function (props) {
  return props.expanded ? "\n        background-color: ".concat(props.activeColor, ";\n\n        &:active, &:hover {\n          background-color: ").concat(darken(props.activeColor, 15), ";\n        }\n      ") : props.name === 'false' ? "\n          background-color: ".concat(colorPalette.beige, ";\n\n          &:active, &:hover {\n            background-color: ").concat(darken(colorPalette.beige, 15), ";\n          }\n      ") : "\n          background-color: ".concat(colorPalette.lightBeige, ";\n\n          &:active, &:hover {\n            background-color: ").concat(darken(colorPalette.lightBeige, 15), ";\n          }\n      ");
}, function (props) {
  return props.expanded ? props.maxHeight : '0';
}, function (props) {
  return props.expanded ? 'scaleY(-1)' : 'scaleY(1)';
});
var CaretContainer = styled.i(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var SubNav = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  overflow: hidden;\n"])), colorPalette.lightGrey);
var SubMenuItem = styled(Link)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 280rem;\n  padding: 20rem 30rem;\n  box-sizing: border-box;\n  font-family: ", ";\n  font-size: 18rem;\n  line-height: 23rem;\n  color: ", ";\n"])), fonts.primary, colorPalette.beige);
var SubMenuItemLabel = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  ", " &:hover:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: -10rem;\n    width: 100%;\n    height: 4rem;\n    background-color: ", ";\n    border-radius: 0 0 3rem 0;\n  }\n"])), function (props) {
  return props.isActive ? "\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      bottom: -10rem;\n      width: 100%;\n      height: 4rem;\n      background-color: ".concat(props.activeColor, ";\n      border-radius: 0 0 3rem 0;\n    }\n  ") : '';
}, function (props) {
  return props.activeColor;
});
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(MobileMenu));